import { Injectable } from '@angular/core';
//import { RootScopeService } from './root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerAlertsService {

  constructor() {

  }
  alertListDataMap: any = {};  // caching  alert data list
  /** 
* deleteEntryCustAlertMap() -- deleting API cached data  alerts list for a customer account tab.
* @author :Amarjeet Kumar
*/
  deleteEntryCustAlertMap(tabId) {
    delete this.alertListDataMap[tabId];
  }
}
